import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import TopNavigationDrawerMobile from 'components/TopNavigationDrawerMobile';
import TopNavigationHeaderMobile from 'components/TopNavigationHeaderMobile';
import {
  PaneManager,
  Pane,
  POSITIONS as PANE_POSITIONS,
} from 'components/TopNavigationPaneManager';
import TopNavigationSubNavigationMobile from 'components/TopNavigationSubNavigationMobile';
import { POSITIONS as OPTION_POSITIONS, TYPES } from 'constants/topNavigation';

const TopNavigationMobile = ({
  l0ActiveNode,
  l1ActiveNode,
  l2ActiveNode,
  openCart,
  setCurrentTopNavigationNode,
  toggleTopNavigation,
  isCartOpen,
  cartItemCount,
  trackNavigation,
  trackNavigationClick,
  trackSearchNavigation,
  trackNavigationRerunRenamingExperimentEngagement,
  showSearch,
  openQuickSearch,
  closeQuickSearch,
  isQuickSearchOpen,
  navigationRerunRenamingExperimentAnalyticsData,
}) => {
  let l1PanePosition = PANE_POSITIONS.RIGHT;
  let l2PanePosition = PANE_POSITIONS.RIGHT;
  let l3PanePosition = PANE_POSITIONS.RIGHT;

  if (l0ActiveNode) {
    l1PanePosition = PANE_POSITIONS.CENTER;
  }

  if (l1ActiveNode) {
    l1PanePosition = PANE_POSITIONS.LEFT;
    l2PanePosition = PANE_POSITIONS.CENTER;
  }

  if (l2ActiveNode) {
    l1PanePosition = PANE_POSITIONS.LEFT;
    l2PanePosition = PANE_POSITIONS.LEFT;
    l3PanePosition = PANE_POSITIONS.CENTER;
  }

  return (
    <div className="TopNavigationMobile" id="top-navigation">
      <TopNavigationHeaderMobile
        isTopNavigationOpen={!!l0ActiveNode}
        toggleTopNavigation={toggleTopNavigation}
        itemCount={cartItemCount}
        openCart={openCart}
        isCartOpen={isCartOpen}
        trackNavigation={trackNavigation}
        trackNavigationClick={trackNavigationClick}
        trackSearchNavigation={trackSearchNavigation}
        showSearch={showSearch}
        openQuickSearch={openQuickSearch}
        closeQuickSearch={closeQuickSearch}
        isQuickSearchOpen={isQuickSearchOpen}
      />
      <TopNavigationDrawerMobile isTopNavigationOpen={!!l0ActiveNode}>
        <PaneManager>
          <Pane position={l1PanePosition}>
            <TopNavigationSubNavigationMobile
              level={TYPES.LEVEL_1}
              node={l0ActiveNode}
              parentNode={null}
              setCurrentTopNavigationNode={setCurrentTopNavigationNode}
              trackNavigation={trackNavigation}
              trackNavigationClick={trackNavigationClick}
              trackNavigationRerunRenamingExperimentEngagement={
                trackNavigationRerunRenamingExperimentEngagement
              }
              navigationRerunRenamingExperimentAnalyticsData={
                navigationRerunRenamingExperimentAnalyticsData
              }
            />
          </Pane>
          <Pane position={l2PanePosition}>
            <TopNavigationSubNavigationMobile
              level={TYPES.LEVEL_2}
              node={l1ActiveNode}
              parentNode={l0ActiveNode}
              setCurrentTopNavigationNode={setCurrentTopNavigationNode}
              trackNavigation={trackNavigation}
              trackNavigationClick={trackNavigationClick}
            />
          </Pane>
          <Pane position={l3PanePosition}>
            <TopNavigationSubNavigationMobile
              level={TYPES.LEVEL_3}
              l0Label={get(l0ActiveNode, 'label')}
              node={l2ActiveNode}
              parentNode={l1ActiveNode}
              setCurrentTopNavigationNode={setCurrentTopNavigationNode}
              trackNavigation={trackNavigation}
              trackNavigationClick={trackNavigationClick}
            />
          </Pane>
        </PaneManager>
      </TopNavigationDrawerMobile>
      <style jsx>
        {`
          .TopNavigationMobile {
            position: relative;
          }
        `}
      </style>
    </div>
  );
};

const nodePropType = PropTypes.shape({
  subNavigations: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      label: PropTypes.string.isRequired,
      position: PropTypes.oneOf(Object.values(OPTION_POSITIONS)),
      subNavigations: PropTypes.arrayOf(PropTypes.shape({})),
      id: PropTypes.string.isRequired,
    })
  ).isRequired,
  icon: PropTypes.element,
  isActive: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
});

TopNavigationMobile.propTypes = {
  l0ActiveNode: nodePropType,
  l1ActiveNode: nodePropType,
  l2ActiveNode: nodePropType,
  openCart: PropTypes.func.isRequired,
  setCurrentTopNavigationNode: PropTypes.func.isRequired,
  toggleTopNavigation: PropTypes.func.isRequired,
  isCartOpen: PropTypes.bool.isRequired,
  cartItemCount: PropTypes.number,
  trackNavigation: PropTypes.func.isRequired,
  trackNavigationClick: PropTypes.func.isRequired,
  trackNavigationRerunRenamingExperimentEngagement: PropTypes.func.isRequired,
  trackSearchNavigation: PropTypes.func.isRequired,
  showSearch: PropTypes.bool.isRequired,
  openQuickSearch: PropTypes.func.isRequired,
  closeQuickSearch: PropTypes.func.isRequired,
  isQuickSearchOpen: PropTypes.bool.isRequired,
  navigationRerunRenamingExperimentAnalyticsData: PropTypes.shape({
    dyDecisionId: PropTypes.string,
    dyVariationId: PropTypes.number,
  }),
};

TopNavigationMobile.defaultProps = {
  l0ActiveNode: null,
  l1ActiveNode: null,
  l2ActiveNode: null,
  cartItemCount: 0,
  navigationRerunRenamingExperimentAnalyticsData: null,
};

export default TopNavigationMobile;
